module.exports = __webpack_public_path__ + "static/media/game-result-en.ed7c23a4.png";